export enum CarLicenseEnum {
  //never change order
  LICENSE_AVAILABLE,
  CAR_AND_LICENSE_AVAILABLE,
}
